import { createContext, ReactNode, useContext } from 'react';

interface KycFormScope {
	organizationId?: string;
}

// Defaults to the programme tier, whose ids come from the route — so only the organisation
// page has to provide anything.
const KycFormScopeContext = createContext<KycFormScope>({});

export const KycFormScopeProvider = ({
	children,
	organizationId,
}: {
	children: ReactNode;
	organizationId?: string;
}) => (
	<KycFormScopeContext.Provider value={{ organizationId }}>
		{children}
	</KycFormScopeContext.Provider>
);

export const useKycFormScope = (): KycFormScope => useContext(KycFormScopeContext);
